import React, { useState } from 'react'
import { Button, Modal, Form } from 'react-bootstrap'
import { GetCbuResponse } from '../../../Api/CBU/models'
import { updateCbuInformation } from '../../../Api/CBU/Cbu'
import toast from 'react-hot-toast'

interface EditCbuModalProps {
    show: boolean
    onHide: () => void
    cbuData: GetCbuResponse | null
    getCbuInfo: () => void
}

export const EditCbuModal = ({ show, onHide, cbuData, getCbuInfo }: EditCbuModalProps) => {

    const [cbu, setCbu] = useState(cbuData?.CBU || '')
    const [alias, setAlias] = useState(cbuData?.alias || '')
    const [titular, setTitular] = useState(cbuData?.titular || '')
    const [hourLimit, setHourLimit] = useState(cbuData?.hour_limit || '')

    const handleSave = async () => {
        const cbuData = {
            CBU: cbu,
            alias,
            titular,
            hour_limit: hourLimit
        }
        const result = await updateCbuInformation(cbuData as GetCbuResponse)
        if (result) {
            toast.success('Información de CBU actualizada correctamente')
            getCbuInfo()
            onHide()
        }
    }

    return (
        <Modal show={show} onHide={onHide}>
            <div className="border border-secondary rounded-3">
                <Modal.Header closeButton>
                    <Modal.Title>Editar Información de CBU</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicCBU">
                            <Form.Label>CBU</Form.Label>
                            <Form.Control type="text" placeholder="Ingrese el CBU" value={cbu} onChange={(e) => setCbu(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicAlias">
                            <Form.Label>Alias</Form.Label>
                            <Form.Control type="text" placeholder="Ingrese el alias" value={alias} onChange={(e) => setAlias(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicTitular">
                            <Form.Label>Titular</Form.Label>
                            <Form.Control type="text" placeholder="Ingrese el titular" value={titular} onChange={(e) => setTitular(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicHourLimit">
                            <Form.Label>Hora Límite</Form.Label>
                            <Form.Control type="text" placeholder="Ingrese la hora límite" value={hourLimit} onChange={(e) => setHourLimit(e.target.value)} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>
    )
}
